import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { isEmpty } from 'lodash'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'

import GlobalItems from 'components/Item'
import ListFilters from 'components/Item/ListFilters'
import Layout from 'components/Layout'

import { loadFilteredItems } from 'store/Items/actions'
import { getCurrentVenueUuid } from 'store/Venues/selector'
import { loadPriceLevels } from 'store/PriceLevels/actions'
import { loadSalesEventTypes } from 'store/SalesEventTypes/actions'
import { loadCategories } from 'store/Categories/actions'
import { loadMenus } from 'store/Menus/actions'
import { loadRevenueCenters } from 'store/RevenueCenters/actions'
import { getQueryStringParameters } from 'store/AppState/selector'
import { loadItemMappings } from 'store/ItemMappings/actions'
import { getIsItemsLoading } from 'store/Items/selector'
import { getIsPriceLevelsLoading } from 'store/PriceLevels/selectors'
import { getIsRevenueCentersLoading } from 'store/RevenueCenters/selector'
import { getIsCategoriesLoading } from 'store/Categories/selectors'
import { getIsSalesEventsLoading } from 'store/SalesEvents/selectors'
import { getIsMenusLoading } from 'store/Menus/selectors'
import { getIsItemMappingsLoading } from 'store/ItemMappings/selectors'

const Items = () => {
  const { pathname } = useLocation()
  const dispatch = useDispatch()

  const currentVenueUuid = useSelector(getCurrentVenueUuid)
  const queryStringParameters = useSelector((state) =>
    getQueryStringParameters(state, pathname)
  )
  const isLoadingItems = useSelector(getIsItemsLoading)
  const isLoadingPriceLevels = useSelector(getIsPriceLevelsLoading)
  const isLoadingRevenueCenters = useSelector(
    getIsRevenueCentersLoading
  )
  const isLoadingCategories = useSelector(getIsCategoriesLoading)
  const isLoadingSalesEvents = useSelector(getIsSalesEventsLoading)
  const isMenusLoading = useSelector(getIsMenusLoading)
  const isItemMappingsLoading = useSelector(getIsItemMappingsLoading)

  const queryStringParametersWithVenue = {
    ...queryStringParameters,
    venueUuid: currentVenueUuid,
  }

  const isLoading =
    isLoadingItems ||
    isLoadingPriceLevels ||
    isLoadingRevenueCenters ||
    isLoadingCategories ||
    isLoadingSalesEvents ||
    isMenusLoading ||
    isItemMappingsLoading

  useEffect(() => {
    if (!isEmpty(currentVenueUuid)) {
      dispatch(loadPriceLevels(currentVenueUuid))
      dispatch(loadSalesEventTypes(currentVenueUuid))
      dispatch(loadCategories(currentVenueUuid))
      dispatch(loadMenus(currentVenueUuid))
      dispatch(loadRevenueCenters(currentVenueUuid))
      dispatch(loadFilteredItems(queryStringParametersWithVenue))
      dispatch(loadItemMappings())
    }
    //eslint-disable-next-line
  }, [currentVenueUuid, dispatch])

  return (
    <Layout
      mainContent={
        <GlobalItems
          queryStringParameters={queryStringParametersWithVenue}
          isLoading={isLoading}
        />
      }
      navbarContent={
        <ListFilters
          queryStringParameters={queryStringParametersWithVenue}
          key={queryStringParameters?.searchFor}
        />
      }
      isSidebar
      title="Items"
    />
  )
}

export default Items
